module.exports = __webpack_public_path__ + "static/media/foto4.932365e6.png";